module.exports = __webpack_public_path__ + "img/a-banner-9@2x.d3007c6f.png";